import { UserRole, UserType } from '@/shared/schema/globalTypes';
import * as Sentry from '@sentry/browser';
import LogRocket from 'logrocket';
import * as Oidc from 'oidc-client';
import Vue from 'vue';
import { compose, inject, withProps } from 'vue-compose';
import { createHOCc } from 'vue-hoc';
import GET_CURRENT_USER from './current-user.graphql';
Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.INFO;
const mgr = new Oidc.UserManager({
    authority: 'https://ou.okta.com',
    client_id: '0oamzuc3q1JFlWyoj0x7',
    redirect_uri: `${window.location.protocol}//${window.location.host}/`,
    response_type: 'id_token token',
    scope: 'openid email profile',
    post_logout_redirect_uri: window.location.origin,
    silent_redirect_uri: window.location.origin + '/silent_renew',
    popup_redirect_uri: window.location.origin + '/popup',
    popup_post_logout_redirect_uri: window.location.origin + '/signout-popup',
    accessTokenExpiringNotificationTime: 10,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    ...(window.location.host == 'localhost:6006'
        ? {
            userStore: {
                get: async () => `{"id_token":"eyJraWQiOiJjVDBpbW1IVDJCb1dqQVAwOUs1Skp5dEtjTEwyWk14VXM1NWV6b3FnRjVzIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwMHU3cnpuNjRmTFFmcjlwaTB4NyIsIm5hbWUiOiJBdmkgQmxvY2siLCJlbWFpbCI6ImFibG9ja0BvdS5vcmciLCJ2ZXIiOjEsImlzcyI6Imh0dHBzOi8vb3Uub2t0YS5jb20iLCJhdWQiOiIwb2FtenVjM3ExSkZsV3lvajB4NyIsImlhdCI6MTYwNDIzMjY0NCwiZXhwIjoxNjA0MjM2MjQ0LCJqdGkiOiJJRC5NUXB5ZndZejlrUUptcmV2UlZvbFIwbTR4SzNHYWMwMkJIcEJ3Wl85aUh3IiwiYW1yIjpbIm1mYSIsInB3ZCIsInN3ayJdLCJpZHAiOiIwb2ExeHprYXhhb3FjenhYRjB4NyIsIm5vbmNlIjoiMDU2ZjNmMzUwNzgzNDczOGEyOWExYWE0YjBhZTk2NGEiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJhYmxvY2tAb3Uub3JnIiwiYXV0aF90aW1lIjoxNjAzOTkyODA1LCJhdF9oYXNoIjoiX3hiel9QVGo5aHljdWlLTXhfTXZndyJ9.ahBimZTQEubxor1g06zBvHBlAkRyr40KRRhuun1IeuhM43FVqUB_JKQdNlqgkC0HFKiAPOzXq8gVbKPNCQ93CUsFgfZpFIzyA4er3ZvLZkXzJ-mFSGUhMkBqG5sbo1-3zWcVRNiAGbeu6wneixqY85o1xNVU6kwih9hXIVpTqHa5k9jBT4VpgC5W98wCy7suFB1iYV5H_p3l__fAYK2aSyezQ4i-VJ3kgRGDbXnVMaQDDF0BtvAC3ALyhQ6YXGKoKKeqir_XiAm1qG5fN5_XAyC6XT2K_xk5fLBxnTK1vhw_KDWjt6mF_0X8dwmTyICt9L5czodIb9R6upRaFoHwlA","access_token":"eyJraWQiOiJxLW9GNWtFWHZwVWp1dFlBTGFmaFd0LXJJX2F6TDR5N24zbzdSTnExemRZIiwiYWxnIjoiUlMyNTYifQ.eyJ2ZXIiOjEsImp0aSI6IkFULlFtX3FHVzNTaGtNQmpyVElWenhHeVQ5QUh5TldmWkRlRkJldl92bkhUSTAiLCJpc3MiOiJodHRwczovL291Lm9rdGEuY29tIiwiYXVkIjoiaHR0cHM6Ly9vdS5va3RhLmNvbSIsInN1YiI6ImFibG9ja0BvdS5vcmciLCJpYXQiOjE2MDQyMzI2NDQsImV4cCI6MTYwNDIzNjI0NCwiY2lkIjoiMG9hbXp1YzNxMUpGbFd5b2oweDciLCJ1aWQiOiIwMHU3cnpuNjRmTFFmcjlwaTB4NyIsInNjcCI6WyJvcGVuaWQiLCJlbWFpbCIsInByb2ZpbGUiXX0.Y9TJnt-e6uSd5bbEYi97QOS32cLzAlClBYZyo3_2LUz6vUdAFBwdOYDFSn-S1ryVzR4Ud29Z_b2QXn9Z8yXyJSZXfOK9qEE_X_wyS_HcYhrk3HSuzVxNEjIEqAhR0RqusAN0yFA41bwhYr56PHtQ1bBaNi-uC0doZQvISAUut9zcdCNXnIuk89YI39wAPSc_tvcK2nfh0F8DPcW6fECZvQOd4YDg66T_T_Ay46aLXE-2D4ZDGuNhEhij3_EcalDuzg5l7UmT_oHc496jD14w9snCy7ueo6kEM9D8KfxTiTkL4BVzhqpnAZo0lL8hWi43I5K4S_teaALpP67nac5zRQ","token_type":"Bearer","scope":"openid+email+profile","profile":{"sub":"00u7rzn64fLQfr9pi0x7","name":"Avi Block","email":"ablock@ou.org","ver":1,"jti":"ID.MQpyfwYz9kQJmrevRVolR0m4xK3Gac02BHpBwZ_9iHw","amr":["mfa","pwd","swk"],"idp":"0oa1xzkaxaoqczxXF0x7","preferred_username":"ablock@ou.org","auth_time":1603992805,"locale":"en-US","given_name":"Avi","family_name":"Block","zoneinfo":"America/Los_Angeles","updated_at":1568230917,"email_verified":true,"userinfo_endpoint":"https://ou.okta.com/oauth2/v1/userinfo","jwks_uri":"https://ou.okta.com/oauth2/v1/keys"},"expires_at":7604236245}`,
                getAllKeys: async () => [''],
                remove: async () => { },
                set: async () => { }
            }
        }
        : {})
});
//@ts-ignore
window.mgr = mgr;
function tryJsonParse(string) {
    try {
        return JSON.parse(string);
    }
    catch (e) {
        return;
    }
}
function getDestination() {
    const destination = tryJsonParse(localStorage.destination);
    if (!Array.isArray(destination))
        return [];
    return destination;
}
const Store = Vue.extend({
    data: () => ({
        state: 'idle',
        user: null,
        authenticating: false,
        needsToReauthenticate: false,
        confirmedReauthentication: false,
        emulatedUser: localStorage.emulatedUser || null
    }),
    async created() {
        if (location.href.match('silent_renew')) {
            mgr.signinSilentCallback();
            return;
        }
        if (location.href.match('signup-popup')) {
            mgr.signoutPopupCallback();
            return;
        }
        if (location.href.match('popup')) {
            mgr.signinSilentCallback();
            return;
        }
        if (location.href.match('managerrequest')) {
            this.state = 'managerRequest';
            return;
        }
        if (location.href.match('accountingpledge')) {
            this.state = 'accountingPledgeRequest';
            return;
        }
        this.user = await mgr.getUser();
        if (this.user && !this.user.expired) {
            this.state = 'authenticated';
            return;
        }
        if (window.location.hash.match('#id_token')) {
            this.state = 'authenticating';
            await mgr.signinRedirectCallback();
            const destinations = getDestination();
            const destination = destinations.pop() || '/';
            localStorage.destination = JSON.stringify(destinations);
            location.href = destination;
        }
        else {
            this.state = 'needslogin';
            this.login();
        }
    },
    methods: {
        async login() {
            const destination = getDestination();
            destination.push(window.location.href);
            localStorage.destination = JSON.stringify(destination);
            await mgr.signinRedirect();
        },
        loginPopup() {
            return mgr.signinPopup();
        },
        logoutPopup() {
            return mgr.signoutPopup();
        },
        async logout() {
            mgr.signoutRedirect();
        }
    },
    computed: {
        name() {
            return this.user?.profile?.name || '';
        }
    }
});
let authStore;
export const getAuthStore = () => {
    authStore = authStore || new Store();
    return authStore;
};
mgr.events.addUserLoaded(user => {
    authStore.user = user;
});
mgr.events.addSilentRenewError(() => {
    mgr.signoutRedirect();
});
export const withCurrentUser = compose(inject(['userProvider']), withProps(function () {
    return {
        currentUser: this.userProvider.user,
        originalUser: this.userProvider.actualUser,
        emulateUser: this.userProvider.emulateUser,
        hasRole: this.userProvider.hasRole,
        canGenerateInvoicesAndReceipts: this.userProvider.canGenerateInvoicesAndReceipts,
        access_token: this.userProvider.access_token
    };
}));
/** WARNING: THIS CODE IS (almost) TOTALLY NOT TYPESAFE **/
export const userProvider = createHOCc({
    name: 'CurrentUserProvider',
    data() {
        return {
            actualUser: null,
            emulatedUser: getAuthStore().emulatedUser
        };
    },
    apollo: {
        actualUser: {
            query: GET_CURRENT_USER,
            update: (data) => data.currentUser,
            result: (result) => {
                if (!result.data || !result.data.currentUser)
                    return;
                const user = result.data.currentUser;
                // if (process.env.VUE_APP_INTERCOM_APP_ID) {
                // 	;(window as any).Intercom('boot', {
                // 		app_id: process.env.VUE_APP_INTERCOM_APP_ID,
                // 		email: user.email,
                // 		user_id: user.id
                // 	})
                // 	if (process.env.VUE_APP_ENABLE_LOGROCKET) {
                // 		LogRocket.getSessionURL(function(sessionURL) {
                // 			;(window as any).Intercom('trackEvent', 'LogRocket', { sessionURL: sessionURL })
                // 		})
                // 	}
                // }
                if (process.env.VUE_APP_ENABLE_LOGROCKET) {
                    LogRocket.identify(user.id, {
                        name: `${user.firstName} ${user.lastName}`,
                        email: user.email,
                        type: user.type,
                        roles: user.roles.join(',')
                    });
                }
                if (process.env.VUE_APP_ENABLE_SENTRY)
                    Sentry.setUser({ email: user.email });
            }
        }
    },
    methods: {
        emulateUser(id) {
            //@ts-ignore
            this.emulatedUser = id;
            authStore.emulatedUser = id;
            if (!id)
                localStorage.removeItem('emulatedUser');
            else
                localStorage.emulatedUser = id;
        },
        hasRole(role) {
            return this.user ? this.user.roles.includes(role) : false;
        },
        canGenerateInvoicesAndReceipts() {
            if (!this.user) {
                return false;
            }
            if (this.user.roles.includes(UserRole.GenerateInvoicesAndReceipts)) {
                return true;
            }
            return this.user.type !== UserType.Fundraiser && this.user.type !== UserType.DepartmentManager;
        }
    },
    computed: {
        user() {
            if (!this.actualUser)
                return null;
            let user = this.emulatedUser
                ? this.actualUser.emulateableUsers.find((x) => x.id === this.emulatedUser)
                : this.actualUser;
            return user || this.actualUser;
        },
        access_token() {
            return authStore.user ? authStore.user.access_token : null;
        }
    },
    provide() {
        return {
            userProvider: this
        };
    }
}, {
    props: {
        loading() {
            return this.$apollo.queries.actualUser?.loading || !this.user;
        }
    }
});
